import { Text, ActionList } from "@certn/cascadia";
import { useClientPortalAPI } from "@certn/api";
import { useTranslation } from "react-i18next";
import { Container, Loader } from "@certn/cascadia-react";
import { CheckRuleSetActionListItem } from "../CheckRuleSetActionListItem";
import { CCRCAdjudicationCodes } from "./CCRCAdjudicationCodes";
import { useFormikContext } from "formik";
import type { SubCategory } from "../../types/canadian-criminal-record-types";
import type {
  AdjudicationFormValues,
  BasicCanadianCriminalRecordCriteria,
} from "../../types/form-values";

interface CCRCAdjudicationCriteriaProps {
  selectedSubCategory: SubCategory | null;
  onSubCategorySelect: (subCategory: SubCategory) => void;
  editMode?: boolean;
}

export function CCRCAdjudicationCriteria({
  selectedSubCategory,
  onSubCategorySelect,
  editMode = false,
}: CCRCAdjudicationCriteriaProps) {
  const { t } = useTranslation();
  const { data: subCategories, isLoading: isSubCategoriesLoading } =
    useClientPortalAPI(
      "/api/internal/client-portal/adjudication-rubrics/subcategories/",
      {
        check_type: "BASIC_CANADIAN_CRIMINAL_RECORD_REPORT_1",
      }
    );
  const { values } = useFormikContext<AdjudicationFormValues>();
  const criteria = values.criteria.find(
    (c): c is BasicCanadianCriminalRecordCriteria =>
      c.check_type === "BASIC_CANADIAN_CRIMINAL_RECORD_REPORT_1"
  );

  return (
    <Container>
      {selectedSubCategory ? (
        <CCRCAdjudicationCodes subCategory={selectedSubCategory} />
      ) : (
        <>
          <Text style="global/title-small">
            {editMode ? t("Edit rules:") : t("Create rules:")}{" "}
            {t("Canadian Criminal Record Check")}
          </Text>
          {isSubCategoriesLoading ? (
            <Loader />
          ) : (
            <ActionList>
              {subCategories?.map((subCategory: SubCategory) => (
                <CheckRuleSetActionListItem
                  title={subCategory.label}
                  key={subCategory.value}
                  onPress={() => {
                    onSubCategorySelect(subCategory);
                  }}
                  tag={
                    criteria?.ruleset?.find(
                      (item) => item.category === subCategory.value
                    )?.set
                      ? "SET"
                      : "NOT_SET"
                  }
                />
              ))}
            </ActionList>
          )}
        </>
      )}
    </Container>
  );
}
